/**
 * Me store routes
 */
export default [
  {
    path: "me/store",
    name: "me.store",
    component: () => import("./index"),
    meta: {
      sort: -1,
      visible: true,
      label: "menu.me_store",
      icon: "store",
      breadcrumb: {
        title: "Minha Loja",
        icon: "store",
        name: "me.store",
        path: "/me/store"
      }
    },
  },
];
